import React from "react";
import When from "../../../../components/utils/When";
import styles from "./SimpleProperties.module.css";
import { BACKDROP_FILTER } from "../../../../constants/MergeConstants";
import { hasBackdropFilter } from "@/utils/Element/FilterUtils";
import { ADVANCED_FILL_MODE_PRESETS } from "../../../../constants/AdvancedFillModePresetConstants";
import darkerBlur from "../../../../../assets/img/darker-blur.jpg";
import lighterBlur from "../../../../../assets/img/lighter-blur.jpg";
import glassyBlur from "../../../../../assets/img/glassy-blur.jpg";
import colorTintBlur from "../../../../../assets/img/color-tint-blur.jpg";

const presetImageMap = {
  "darker": darkerBlur,
  "lighter": lighterBlur,
  "glassy": glassyBlur,
  "color-tint": colorTintBlur,
};

export default function AdvancedFillPresets({
  isLocked,
  getValue,
  handlePresetSelect,
  isSplit = false,
}) {
  return (
    <When it={hasBackdropFilter(getValue(BACKDROP_FILTER))}>
      <div className={`${styles["preset-section"]} ${isSplit ? styles.split : ""}`}>
        <div className={styles.presetLabelRow}>
          <label className={styles.presetLabel}>Presets</label>
        </div>
        <div className={styles["presetOptions"]}>
          {Object.keys(ADVANCED_FILL_MODE_PRESETS).map((presetId) => (
            <button
              key={presetId}
              className={`${styles["preset-button"]}`}
              style={{ backgroundImage: `url(${presetImageMap[presetId]})` }}
              onClick={() => handlePresetSelect(presetId)}
              disabled={isLocked}
            />
          ))}
        </div>
      </div>
    </When>
  );
}